/* WOWFRIDAY — landing + ponte verso il configuratore bundle esistente (v16) e VOPO.
   Config: <script type="application/json" id="wf-config"> generato da wowfriday-hero.liquid (impostazioni sezione).
   Varianti: <script type="application/json" id="wf-variants"> = product.variants (prezzo per Posizione stampa). */
(function(){
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
var C={};try{C=JSON.parse(($('#wf-config')||{}).textContent||'{}')}catch(e){}
var V=[];try{V=JSON.parse(($('#wf-variants')||{}).textContent||'[]')}catch(e){}
var pad=function(n){return String(n).padStart(2,'0')};
var eur=function(c){return '€'+(c/100).toFixed(2).replace('.',',')};

/* ---------- prezzo (dalla variante reale) ---------- */
var cur=V.filter(function(v){return String(v.id)===String(C.variantId)})[0]||V[0]||{price:C.price||0,compare_at_price:null};
function renderPrice(v){
  var price=v.price,was=v.compare_at_price||C.wasPrice||0,pieces=C.pieces||1;
  $$('[data-price]').forEach(function(el){el.textContent=eur(price)});
  $$('[data-was]').forEach(function(el){el.textContent=was>price?eur(was):'';el.hidden=!(was>price)});
  $$('[data-off]').forEach(function(el){var off=was>price?Math.round((1-price/was)*100):0;el.textContent=off?'-'+off+'%':'';el.hidden=!off});
  $$('[data-save]').forEach(function(el){el.textContent=was>price?eur(was-price):''});
  $$('[data-unit]').forEach(function(el){el.textContent=eur(Math.round(price/pieces))});
  var idIn=$('#ws-product-form-summary [name="id"]');if(idIn)idIn.value=v.id;
}
renderPrice(cur);
function onVariant(id){var v=V.filter(function(x){return String(x.id)===String(id)})[0];if(v&&v!==cur){cur=v;renderPrice(v)}}

/* ---------- countdown / giorni / stock ---------- */
function sundayEnd(){var d=new Date(),add=(7-d.getDay())%7;return new Date(d.getFullYear(),d.getMonth(),d.getDate()+add,23,59,59)}
var end=C.end?new Date(C.end):sundayEnd();
var start=new Date(end.getFullYear(),end.getMonth(),end.getDate()-2,0,0,0);
function tick(){
  var ms=Math.max(0,end-Date.now()),s=Math.floor(ms/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
  $$('[data-t="h"]').forEach(function(el){el.textContent=pad(h+d*24)});
  $$('[data-t="m"]').forEach(function(el){el.textContent=pad(m)});
  $$('[data-t="s"]').forEach(function(el){el.textContent=pad(sec)});
  $$('[data-t="txt"]').forEach(function(el){el.textContent=ms<=0?'terminata':(d?d+'g ':'')+pad(h)+':'+pad(m)+':'+pad(sec)});
  $$('[data-t="endday"]').forEach(function(el){el.textContent=d>=1?'domenica':'stanotte'});
}
tick();setInterval(tick,1000);
var dayIdx={5:0,6:1,0:2},today=new Date().getDay();
$$('.days').forEach(function(w){$$('span',w).forEach(function(s,i){var c=dayIdx[today];s.classList.toggle('is-now',c===i);s.classList.toggle('is-past',c!=null&&i<c)})});
function stockLeft(){
  var initial=Math.max(0,Math.round(+C.stockInitial||0));
  if(!initial||Date.now()>=end.getTime())return 0;
  var progress=Math.min(1,Math.max(0,(Date.now()-start)/(end-start)));
  var curve=2.4;
  var consumed=Math.expm1(curve*progress)/Math.expm1(curve);
  return Math.max(0,Math.min(initial,Math.ceil(initial*(1-consumed))));
}
function renderStock(){
  var initial=Math.max(0,Math.round(+C.stockInitial||0));
  if(!initial){$$('.stock').forEach(function(el){el.hidden=true});return}
  var l=stockLeft();
  $$('[data-stock]').forEach(function(el){el.textContent=l});
  $$('[data-stock-total]').forEach(function(el){el.textContent=initial});
  $$('[data-stock-bar]').forEach(function(el){el.style.width=Math.max(0,Math.round(l/initial*100))+'%'});
}
renderStock();setInterval(renderStock,10000);

/* ---------- ponte configuratore bundle v16 ---------- */
var root=null;
function bundleRoot(){return root&&document.contains(root)?root:(root=$('[data-ws-bundle-configurator]'))}
function fire(el){el.dispatchEvent(new Event('input',{bubbles:true}));el.dispatchEvent(new Event('change',{bubbles:true}))}
function skinSizes(scope){
  $$('input.ws-bundle-size__qty',scope).forEach(function(inp){
    if(inp.dataset.wfStep)return;inp.dataset.wfStep='1';
    var w=document.createElement('div');w.className='wf-step';
    var minus=document.createElement('button'),plus=document.createElement('button');
    minus.type=plus.type='button';minus.textContent='−';plus.textContent='+';
    var lab=(inp.getAttribute('aria-label')||'').replace(/^Quantità\s*/i,'');
    minus.setAttribute('aria-label','Togli '+lab);plus.setAttribute('aria-label','Aggiungi '+lab);
    inp.parentNode.insertBefore(w,inp);w.appendChild(minus);w.appendChild(inp);w.appendChild(plus);
    function step(d){var v=(+inp.value||0)+d,max=inp.max!==''?+inp.max:Infinity;v=Math.max(0,Math.min(max,v));inp.value=v||'';fire(inp);mark()}
    minus.addEventListener('click',function(){step(-1)});
    plus.addEventListener('click',function(){step(1)});
    inp.addEventListener('input',mark);
    function mark(){var c=inp.closest('.ws-bundle-size');if(c)c.classList.toggle('is-on',(+inp.value||0)>0)}
    mark();
  });
}
function compactLabel(value){
  return String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
}
function embedGlobalOptions(r){
  $$('[data-ws-bundle-global-option]',r).forEach(function(option){
    var optionName=option.getAttribute('data-option-name')||'';
    var productName=optionName.split(/\s*\(/)[0];
    if(!productName||productName===optionName)return;
    var product=$$('[data-ws-bundle-product]',r).find(function(node){
      return compactLabel(node.getAttribute('data-component-title'))===compactLabel(productName);
    });
    if(!product)return;
    var dynamic=$('[data-ws-bundle-dynamic]',product);
    if(!dynamic||$('.ws-bundle-loading',dynamic))return;
    var positionField=$$('.ws-bundle-field',dynamic).find(function(field){
      var title=$('[data-ws-bundle-field-title]',field);
      return title&&compactLabel(title.textContent).indexOf('posizione stampa')>-1;
    });
    if(option.parentNode!==dynamic){
      if(positionField)dynamic.insertBefore(option,positionField);else dynamic.insertBefore(option,dynamic.firstChild);
      option.classList.add('is-embedded');
    }
    if(!positionField)return;
    positionField.classList.add('is-shadowed-by-global');
    var select=$('select',positionField);
    function syncPosition(){
      var active=$('[data-ws-bundle-global-value][aria-pressed="true"]',option);
      if(!select||!active)return;
      var value=active.value;
      var matching=$$('option',select).find(function(item){return item.value===value});
      if(!matching){matching=document.createElement('option');matching.value=value;matching.textContent=value;select.appendChild(matching)}
      if(select.value!==value){select.value=value;fire(select)}
    }
    if(option.dataset.wfPositionSync!=='1'){
      option.dataset.wfPositionSync='1';
      option.addEventListener('click',function(e){
        if(e.target.closest('[data-ws-bundle-global-value]'))window.setTimeout(syncPosition,0);
      });
    }
    syncPosition();
  });
}
function syncFromRoot(){
  var r=bundleRoot();if(!r)return;
  skinSizes(r);
  embedGlobalOptions(r);
  var id=r.getAttribute('data-ws-selected-variant-id');if(id)onVariant(id);
  if(r.getAttribute('data-ws-bundle-complete')==='true'){var e=$('#wfCfgErr');if(e)e.classList.remove('is-on')}
}
var cfgBox=$('.wf-cfg');
if(cfgBox){
  var mo=new MutationObserver(function(){syncFromRoot()});
  mo.observe(cfgBox,{childList:true,subtree:true,attributes:true,attributeFilter:['data-ws-selected-variant-id','data-ws-bundle-complete']});
  syncFromRoot();
}
/* VOPO senza bundle (prodotto singolo): la select variante aggiorna il prezzo */
document.addEventListener('change',function(e){
  var t=e.target;if(!t||!t.closest)return;
  if(t.matches('#bcpo-select, select[name="vopo-id"], select[name="id"]'))onVariant(t.value);
  if(t.matches('#bcpo select.single-option-selector')){setTimeout(function(){var s=$('#bcpo-select');if(s)onVariant(s.value)},60)}
});

/* ---------- Aggiungi al carrello ---------- */
function firstIncomplete(r){return $$('.ws-bundle-product',r).filter(function(p){return !p.classList.contains('is-complete')})[0]}
function goTo(el){window.scrollTo({top:el.getBoundingClientRect().top+window.scrollY-((parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hd-h'))||90)+16),behavior:'smooth'})}
function addToCart(){
  var form=$('#ws-product-form-summary');if(!form)return;
  var r=bundleRoot(),err=$('#wfCfgErr');
  if(r&&r.getAttribute('data-ws-bundle-complete')!=='true'){
    var p=firstIncomplete(r)||r;
    if(p.classList&&!p.classList.contains('is-open')){var t=$('[data-ws-bundle-toggle]',p);if(t)t.click()}
    if(err){var st=$('[data-ws-bundle-status]',p);err.textContent='Completa '+(($('.ws-bundle-product__heading strong',p)||{}).textContent||'la configurazione')+(st?': '+st.textContent:'');err.classList.add('is-on')}
    goTo(p);return;
  }
  if(r){
    var selectedVariantId=r.getAttribute('data-ws-selected-variant-id')||window.__wsBundleSelectedVariantId;
    var variantInput=$('[name="id"]',form);
    if(selectedVariantId&&variantInput){variantInput.disabled=false;variantInput.value=selectedVariantId;variantInput.setAttribute('value',selectedVariantId)}
    var vals={};try{vals=JSON.parse(r.getAttribute('data-ws-bundle-values')||'{}')}catch(e){}
    Object.keys(vals).forEach(function(k){
      if(vals[k]==null||vals[k]==='')return;
      var n='properties['+k+']';
      var h=document.querySelector('[name="'+CSS.escape(n)+'"][form="ws-product-form-summary"],#ws-product-form-summary [name="'+CSS.escape(n)+'"]');
      if(!h){h=document.createElement('input');h.type='hidden';h.name=n;h.dataset.wfAdded='1';form.appendChild(h)}
      h.disabled=false;h.value=vals[k];h.setAttribute('value',vals[k]);
    });
  }
  var uploadMode=document.querySelector('input[name="ws_bundle_upload_mode"]:checked');
  var uploadModeName='properties[Modalità invio file]';
  var uploadModeInput=form.querySelector('[data-wf-upload-mode-property]');
  if(uploadMode&&uploadMode.value==='later'){
    if(!uploadModeInput){uploadModeInput=document.createElement('input');uploadModeInput.type='hidden';uploadModeInput.name=uploadModeName;uploadModeInput.dataset.wfUploadModeProperty='1';form.appendChild(uploadModeInput)}
    uploadModeInput.disabled=false;uploadModeInput.value='Invio i file dopo';uploadModeInput.setAttribute('value','Invio i file dopo');
  }else if(uploadModeInput){
    uploadModeInput.disabled=true;uploadModeInput.value='';uploadModeInput.setAttribute('value','');
  }
  $$('[data-wf-cta]').forEach(function(b){b.setAttribute('aria-busy','true')});
  if(form.requestSubmit)form.requestSubmit();else form.submit();
}
$$('[data-wf-cta]').forEach(function(b){b.addEventListener('click',addToCart)});

/* ---------- sticky ---------- */
var stk=$('.wf-stk'),hcta=$('#wfAddCart'),fin=$('#finale');
if(stk&&hcta&&'IntersectionObserver' in window){
  var vis={h:true,f:false};
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.target===hcta)vis.h=e.isIntersecting;else vis.f=e.isIntersecting});stk.classList.toggle('is-on',!vis.h&&!vis.f)});
  io.observe(hcta);if(fin)io.observe(fin);
}

/* ---------- use case tabs ---------- */
$$('.uc__tab').forEach(function(tab){tab.addEventListener('click',function(){
  $$('.uc__tab').forEach(function(t){t.setAttribute('aria-selected',t===tab?'true':'false')});
  var f=tab.dataset.f;$$('.uc__card').forEach(function(c){c.hidden=!(f==='all'||(c.dataset.t||'').indexOf(f)>-1)});
})});

/* ---------- toast ordini recenti (solo dati reali in impostazioni) ---------- */
var toast=$('.wf-toast'),list=(C.toasts||[]).filter(function(t){return t&&t[0]}),ti=0;
if(toast&&list.length&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
  setTimeout(function show(){
    var t=list[ti++%list.length];
    toast.innerHTML='<i></i><div><b></b> da <span class="c"></span> ha ordinato il kit'+(t[2]?'<br><span class="w"></span>':'')+'</div>';
    toast.querySelector('b').textContent=t[0];toast.querySelector('.c').textContent=t[1]||'';
    if(t[2])toast.querySelector('.w').textContent=t[2];
    toast.classList.add('is-on');setTimeout(function(){toast.classList.remove('is-on')},5000);setTimeout(show,22000);
  },9000);
}
})();
